import React, { useState } from "react";
import { Link } from "react-router-dom";

type MobileNavProps = {
  isOpen: boolean;
  toggleMenu: () => void;
};

const MobileNav: React.FC<MobileNavProps> = ({ isOpen, toggleMenu }) => (
  <div
    className={`fixed top-0 left-0 w-full h-full bg-gray-500 bg-opacity-90 z-10 ${
      isOpen ? "block" : "hidden"
    }`}
  >
    <button
      className="absolute top-5 right-5 text-white text-[3rem]"
      onClick={toggleMenu}
    >
      &times;
    </button>
    <ul className="flex flex-col items-center justify-center h-full space-y-10">
      <li onClick={toggleMenu}>
        <Link to="/" className="text-white text-3xl hover:text-primary">
          Home
        </Link>
      </li>
      <li onClick={toggleMenu}>
        <Link to="/about" className="text-white text-3xl hover:text-primary">
          About Us
        </Link>
      </li>
      <li onClick={toggleMenu}>
        <Link
          to="/developments"
          className="text-white text-3xl hover:text-primary"
        >
          Developments
        </Link>
      </li>
      {/* <li onClick={toggleMenu}>
        <Link to="/ventures" className="text-white text-3xl hover:text-primary">
          Ventures
        </Link>
      </li> */}
      <li onClick={toggleMenu}>
        <Link
          to="/contact"
          className="bg-primary text-black px-8 py-4 rounded text-3xl hover:bg-yellow-400"
        >
          Contact Us
        </Link>
      </li>
    </ul>
  </div>
);

type NavProps = {};

const Nav: React.FC<NavProps> = () => {
  const [isMenuOpen, setMenuOpen] = useState<boolean>(false);

  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="flex justify-between items-center p-8 z-10">
      <Link to="/">
        <img src="/images/dancap-logo.png" alt="logo" className="h-[5.8rem]" />
      </Link>
      <div className="hidden md:flex">
        <ul
          style={{ backgroundColor: "rgba(255, 255, 255, 0.10)" }}
          className="flex items-center rounded-[0.5rem] space-x-6 px-[1.5rem] py-[0.4rem] mr-[1.2rem]"
        >
          <li className="px-[1.5rem] py-[1rem]">
            <Link to="/" className="hover:text-primary text-[1.5rem]">
              Home
            </Link>
          </li>
          <li className="px-[1.5rem] py-[1rem]">
            <Link to="/about" className="hover:text-primary text-[1.5rem]">
              About Us
            </Link>
          </li>
          <li className="px-[1.5rem] py-[1rem]">
            <Link
              to="/developments"
              className="hover:text-primary text-[1.5rem]"
            >
              Developments
            </Link>
          </li>
          {/* <li className="px-[1.5rem] py-[1rem]">
            <Link to="/ventures" className="hover:text-primary text-[1.5rem]">
              Ventures
            </Link>
          </li> */}
        </ul>
        <Link
          to="/contact"
          className="bg-primary text-black px-[2.2rem] py-[1.4rem] rounded-[0.5rem] text-[1.5rem] hover:bg-yellow-400"
        >
          Contact Us
        </Link>
      </div>
      <button
        className="md:hidden text-[3rem] focus:outline-none"
        onClick={toggleMenu}
      >
        &#9776;
      </button>
      <MobileNav isOpen={isMenuOpen} toggleMenu={toggleMenu} />
    </nav>
  );
};

export default Nav;
